import React from 'react'

interface Props {
  className?: string
  stroke?: string
}
export const CheckIcon = ({ className, stroke = '#000' }: Props) => (
  <svg viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M1 5.35L5.05 9.4l7.8-8.4" stroke={stroke} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
